import { render } from "./Dados.vue?vue&type=template&id=a551e68e"
import script from "./Dados.vue?vue&type=script&lang=js"
export * from "./Dados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__